// fastContext.ts
'use client';
import { IContentModel } from '@ninjacart/nc-nk-core';
import { SharedValue } from 'react-native-reanimated';
import createFastContext from '../context/createFastContext';
import { KVPair } from '../interface/keyValuePair';
import { useAppPersistenceStore } from '../store/useAppPersistenceStore';
import { useEventZStore } from '../store/useEventZStore';

interface HomeContextFields {
  isCommentSheetOpen?: boolean;
  isReportSheetOpen?: boolean;
  feedItem?: IContentModel;
  activeVideoFeedIndex?: number;
  videoFeedIndex?: number;
  headerOffset: SharedValue<number> | undefined;
  adSizeDefsPreloaded: KVPair;
  bannerAdKeywords: string[];
  scrollToIndex: number;
  isMomentumScrollEnded: boolean;
  disableScroll?: boolean;
  askLocationPermissionWeather?: boolean;
  // getVideoFeedIndex: () => number;
}

export const {
  FastContextProvider: HomeFastContextProvider,
  useFastContextFields: useHomeContext,
} = createFastContext<HomeContextFields>({
  isCommentSheetOpen: false,
  isReportSheetOpen: false,
  activeVideoFeedIndex: -1,
  headerOffset: undefined,
  adSizeDefsPreloaded: useAppPersistenceStore.getState().ads.adUnitsWithSizes,
  bannerAdKeywords: useEventZStore.getState().bannerAdKeywords,
  isMomentumScrollEnded: true,
  videoFeedIndex: -1,
  scrollToIndex: -1,
  disableScroll: false,
  askLocationPermissionWeather: false
});